import axios from 'axios';

import { toggleLocationPanel } from '../../../components/locationPanel';
// Yext endpoint to fetch locations
// https://api.yext.com/v2/accounts/me/entities?api_key=bc275d4d9487c19916b70ef74134cf5d&v=20210503&filter=%7B%22name%22%3A%7B%22%24contains%22%3A%22Hoots%22%7D%7D
// eslint-disable-next-line import/prefer-default-export
export const store = {
  favoriteLocation: null,
  foundLocation: null,
  getInitialFavoriteLocation() {
    if (localStorage && localStorage.getItem('favoriteLocation')) {
      try {
        this.favoriteLocation = JSON.parse(localStorage.getItem('favoriteLocation'));
        return this.favoriteLocation;
      } catch (error) {}
    }
  },
  getFavoriteLocation() {
    return this.favoriteLocation;
  },
  setFavoriteLocation(location) {
    location.name = location.name.replace(/hoots wings -/gi, '');
    localStorage.favoriteLocation = JSON.stringify(location);
    this.favoriteLocation = location;
    toggleLocationPanel(location);
  },
  getAllLocations() {
    // self = this;
    // const req = axios.get('/api/locations.php').then(res => {
    //   self.locations = res.data;
    //   console.log('res', res.data);
    // });
  },
  async getLocationBySlug(slug) {
    // const self = this;
    // let locations = await this.getLocations();

    const locations = this.locations.find(loc => loc['c_locationSlug'] === slug);

    // self.foundLocation = res.data.find(loc => loc['c_locationSlug'] === slug);
    return locations;

    // return self.foundLocation;
  },
  async getLocations() {
    const req = await axios.get('/api/locations.php');
    return req.data;
  },
  assetPath() {
    if (process.env.NODE_ENV === 'production') {
      return '/_assets/';
    } else {
      return 'https://hootswings.local/_assets/';
    }
  },
  perchPath() {
    if (process.env.NODE_ENV === 'production') {
      return '/perch/';
    } else {
      return 'https://hootswings.local/perch/';
    }
  },
};
